import axios from 'axios'
import { useUserStore } from '@/stores/UserStore.js'

export const postProgramsCheckup = async (checkupInfo) => {
  const userStore = useUserStore()
  const userId = userStore?.user?.id
  const userToken = userStore?.userToken

  if (!userId) {
    throw new Error('User ID is not available')
  }

  const url = `https://lk.k31.ru/api/v7/checkup/send?user_id=${userId}`

  const response = await axios.post(url, checkupInfo, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json'
    }
  })

  if (response.data.status !== 'ok') {
    throw new Error(
      response.data.message ?? 'Произошла ошибка, попробуйте позже'
    )
  }

  return response.data
}
